import { ReactNode } from "react";
import CSS from 'csstype';

import { classNames } from "~/utils/utils";

import "./style.less";

interface ITableControls {
	children: ReactNode;
	sx?: CSS.Properties;
	className?: string;
}

export default function TableControls({
	children = null,
	className = "",
	sx = {},
}: ITableControls) {
	const divClassName = classNames([
		"tableControls",
		className,
	]);

	return <div className={divClassName} style={sx}>
		{children}
	</div>;
}
